// extracted by mini-css-extract-plugin
module.exports = {"container":"mini-cart-button_container__drwd_"};